import { render, staticRenderFns } from "./StockMomentumView.vue?vue&type=template&id=6cf4105c&scoped=true"
import script from "./StockMomentumView.vue?vue&type=script&lang=js"
export * from "./StockMomentumView.vue?vue&type=script&lang=js"
import style0 from "./StockMomentumView.vue?vue&type=style&index=0&id=6cf4105c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf4105c",
  null
  
)

export default component.exports